import { combineReducers } from "@ngrx/store";

export { beneficiaryReducer } from "./beneficiary.reducers";
export { userReducer } from "./user.reducers";
export { tokenReducer } from "./token.reducers";
export { stateReducer } from "./state.reducers"; 

 
